import { token } from 'sierra-ui/theming'
import styled from 'styled-components'

export const VerticalSeparator = styled.div`
  height: 1rem;
  width: 1px;
  background-color: ${token('border/default')};
`
